import { render, staticRenderFns } from "./TabSwipe.vue?vue&type=template&id=0cc69746&scoped=true"
import script from "./TabSwipe.vue?vue&type=script&lang=js"
export * from "./TabSwipe.vue?vue&type=script&lang=js"
import style0 from "./TabSwipe.vue?vue&type=style&index=0&id=0cc69746&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc69746",
  null
  
)

export default component.exports